import MapBox from './MapBox'

export default {
  getMapData() {
    let mapData = JSON.parse(window.localStorage.getItem('vtRoads'));
    return mapData && mapData.roadList.length ? mapData : { roadList: [] };
  },

  saveMapData(mapData) {
    window.localStorage.setItem('vtRoads', JSON.stringify(mapData));
  },

  clearMapData() {
    let mapData = this.getMapData();
    mapData.roadList = [];

    this.saveMapData(mapData);
  },
  
  isRoadInMyMap(targetRoad) {
    let mapData = this.getMapData();

    if (mapData && mapData.roadList.find(road => road.name == targetRoad.geoJSON.name)) {
      return true;
    } else {
      return false;
    }
  },
  
  isRoadConnector(road) {
    return road.name.indexOf('connector') > -1;
  },

  addRoad(targetRoad) {
    let mapData = this.getMapData();

    if (!this.inMyMap) {
      mapData.roadList.push(targetRoad.geoJSON);
    }

    this.saveMapData(mapData);
  },

  removeRoad(targetRoad) {
    let mapData = this.getMapData();

    mapData.roadList = mapData.roadList.filter(road => {     
      return road.name != targetRoad.name
    });
        
    this.saveMapData(mapData);
    return mapData;
  },

  async createRoutesBetweenRoads (roads) {    
    let routedRoads = [];

    for (const [index, road] of roads.entries()) {
      if (index < roads.length-1) {        
        let currentRoad = road.features[road.features.length-1],
        nextRoad = roads[index+1].features.reverse()[roads[index+1].features.length-1];
        
        let coords =[
          currentRoad.geometry.coordinates.pop(),
          nextRoad.geometry.coordinates.reverse().pop()
        ];

        let response = await MapBox.getDirections(coords);

        let connector = {
          name: `connector-${index}`,
          features: [
            {
              'type': 'Feature',
              'properties': {
                length: response.routes[0].distance
              },
              'geometry': response.routes[0].geometry
            }
          ],
          type: 'FeatureCollection'
        };

        routedRoads.push(road);
        routedRoads.push(connector);
      }
    }
    return routedRoads;
  },

  // directions API can only handle a max of 24 points
  // so this method probably won't work for us long term
  async createSingleRouteFromRoads(roads){
    let coords = [];
    for (const road of roads) {
      for (const feature of road.features) {
        // road start
        coords.push(feature.geometry.coordinates[0]);
  
        // road end
        coords.push(feature.geometry.coordinates[feature.geometry.coordinates.length-1]);
      }
    }
  
    let response = await MapBox.getDirections(coords);

    // geoJson format
    return {
      name: `route`,
      features: [
        {
          'type': 'Feature',
          'properties': {
            length: response.routes[0].distance
          },
          'geometry': response.routes[0].geometry
        }
      ],
      type: 'FeatureCollection'
    };
  }
}